import { createFileRoute, notFound } from "@tanstack/react-router";
import { UniversityDocsPage } from "@/components/University";
import { findPageByPath } from "@/components/University/content";

function RouteComponent() {
  const { entry } = Route.useLoaderData();
  return <UniversityDocsPage entry={entry} />;
}

export const Route = createFileRoute("/_authenticated/atlas/$department/$page")({
  loader: ({ params }) => {
    const entry = findPageByPath(params.department, params.page);
    if (!entry) throw notFound();
    return { entry };
  },
  component: RouteComponent,
  staticData: { page: "university" },
});
